export const COLLECTOR_SERVICE = '/collector/rest/collect-js';
export const QUERY_SERVICE = '/billing/counters/queryservice/query';
export const QUERY_TOP_SERVICE = '/billing/counters/topservice/query';



// WEBPACK FOOTER //
// ./src/shared/constants/stats/endpoints-url.js